import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ModalRoutingService {

  private history = [];

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd && event.url.includes('modal:m/'))
    ).subscribe((event: NavigationEnd) => {
      const modal = event.url.split(':')[1].replace(')', '');
      if (!this.history.includes(modal)) {
        this.history.push(modal);
      } else if (this.history[this.history.length - 2] === modal) {
        this.history.pop();
      }
    });
  }

  reset() {
    this.history = [];
  }

  async back() {
    if (this.canGoBack) {
      await this.router.navigate(['', {outlets: {modal: this.history[this.history.length - 2]}}]);
    }
  }

  get canGoBack() {
    return !!this.history[this.history.length - 2];
  }
}
